import { InputChipProps } from '@cast/design-system';

import { baseChipProps } from './_constants';
import { ApplyRecentSearchValues } from './_types';
import { SearchBoxCriterionGroup } from '../constants';
import { SearchBoxCriterion } from '../types';

export const getValuesWithTitles = (
  criteria: Array<SearchBoxCriterion<any>>,
  values: Record<string, any>,
  activeCriterionKey?: string
): InputChipProps[] => {
  const result: InputChipProps[] = [];
  for (const key in values) {
    if (key === activeCriterionKey) {
      continue;
    }
    const criterion = criteria.find((c) => c.key === key);

    if (criterion) {
      result.push({
        ...baseChipProps,
        key,
        title: criterion.title || key,
        value: criterion.renderOption
          ? criterion.renderOption(values[key], 0)
          : values[key],
      });
    } else {
      result.push({
        ...baseChipProps,
        key,
        title: key,
        value: values[key],
      });
    }
  }
  return result;
};

export const applyRecentSearchValue: ApplyRecentSearchValues = ({
  recentValues,
  contextValues = {},
  allCriteria = [],
}) => {
  const nonSearchValues = allCriteria.reduce((acc, { group, key }) => {
    if (group === SearchBoxCriterionGroup) {
      return acc;
    }

    if (!(key in contextValues)) {
      return acc;
    }

    return {
      ...acc,
      [key]: contextValues[key],
    };
  }, {} as Record<string, any>);

  return {
    ...nonSearchValues,
    ...recentValues,
  };
};
